<template>
    <span :class="badgeClass">
        {{ text }}
    </span>
</template>

<script setup lang="ts">
    import { computed } from 'vue'

    type FeaturePageBadgeVariant =
        'neutral' | 'primary' | 'success' | 'upcoming'

    type FeaturePageBadgeSize = 'xs' | 'sm' | 'md'

    interface FeaturePageBadgeProps {
        text: string
        variant?: FeaturePageBadgeVariant
        size?: FeaturePageBadgeSize
        uppercase?: boolean
    }

    const props = withDefaults(defineProps<FeaturePageBadgeProps>(), {
        variant: 'neutral',
        size: 'sm',
        uppercase: false,
    })

    const badgeClass = computed((): string => {
        const variantClassMap: Record<FeaturePageBadgeVariant, string> = {
            neutral: 'border-slate-200 bg-slate-100 text-slate-700',
            primary:
                'border-primary-shade-ligth bg-primary-shade-ligth text-primary-shade',
            success: 'border-emerald-200 bg-emerald-100 text-emerald-800',
            upcoming: 'border-amber-200 bg-amber-50 text-amber-900',
        }

        const sizeClassMap: Record<FeaturePageBadgeSize, string> = {
            xs: 'px-2 py-0 text-[10px]',
            sm: 'px-3 py-1 text-xs',
            md: 'px-3.5 py-1.5 text-sm',
        }

        const uppercaseClass = props.uppercase
            ? 'uppercase tracking-wide'
            : 'tracking-normal'

        return [
            'inline-flex items-center rounded-full border font-bold',
            variantClassMap[props.variant],
            sizeClassMap[props.size],
            uppercaseClass,
        ].join(' ')
    })
</script>
